var React = require('react');

function PlayButton (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd"},[React.createElement("circle",{"fill":"#8ACEB6","cx":"22.5","cy":"22.5","r":"22.5","key":0}),React.createElement("path",{"fill":"#FFF","d":"M33.5 22.5l-17 10v-20z","key":1})]));
}

PlayButton.defaultProps = {"viewBox":"0 0 45 45"};

module.exports = PlayButton;

PlayButton.default = PlayButton;
